import gql from "graphql-tag";

export const BILLING_SUMMARY_QUERY = gql`
  query billingSummary($startDate: Date!, $endDate: Date!) {
    billingSummary(startDate: $startDate, endDate: $endDate) {
      payfastSubscriptionsTotal
      totalActiveSubscriptions
      totalActiveSubscriptionsTotalOneOnOne
      totalActiveSubscriptionsTotalGrad
      totalActiveSubscriptionsTotalJeffLife
      totalActiveSubscriptionsTotalClub
      totalActiveSubscriptionsTotalGroupJeffLife
      payfastSubscriptionsTotalOneOnOne
      payfastSubscriptionsTotalGrad
      payfastSubscriptionsTotalJeffLife
      payfastSubscriptionsTotalGroupJeffLife
      payfastChallengesTotal
      peachSubscriptionsTotal
      peachSubscriptionsTotalOneOnOne
      peachSubscriptionsTotalJeffLife
      peachSubscriptionsTotalGroupJeffLife
      peachSubscriptionsTotalGrad
      peachSubscriptionsTotalClub
    }
  }
`;

export const PRODUCT_HISTORY_SUMMARY_QUERY = gql`
  query totalSubscriptionsPerProduct($startDate: Date!, $endDate: Date!) {
    totalSubscriptionsPerProduct(startDate: $startDate, endDate: $endDate) {
      month
      day
      week
    }
  }
`;

export const PAYFAST_SUBSCRIPTIONS_WITHOUT_PAYMENTS_QUERY = gql`
  query payfastSubscriptionsWithoutPayments {
    payfastSubscriptionsWithoutPayments {
      paidUpUntil
      subscription {
        id
        active
        endDate
        product {
          id
          type
        }
        user {
          id
          email
          firstName
        }
      }
    }
  }
`;

export const SUBSCRIPTION_SUMMARY_QUERY = gql`
  query subscriptionSummary(
    $reportType: String!
    $startDate: Date!
    $endDate: Date!
    $period: String!
    $acquisitionTypes: [String]
    $corporateTypes: [String]
    $discountCategories: [ID]
    $noDiscounts: Boolean
    $transitionProductTypes: [String]
    $endTypes: [String]
  ) {
    subscriptionSummary(
      reportType: $reportType
      startDate: $startDate
      endDate: $endDate
      period: $period
      acquisitionTypes: $acquisitionTypes
      corporateTypes: $corporateTypes
      discountCategories: $discountCategories
      noDiscounts: $noDiscounts
      transitionProductTypes: $transitionProductTypes
      endTypes: $endTypes
    ) {
      data
    }
  }
`;

export const CANCELLATIONS_SUMMARY_QUERY = gql`
  query totalCancellationsPerProduct(
    $startDate: Date!
    $endDate: Date!
    $excludeTransitions: Boolean
    $transitionProductId: ID
  ) {
    totalCancellationsPerProduct(
      startDate: $startDate
      endDate: $endDate
      excludeTransitions: $excludeTransitions
      transitionProductId: $transitionProductId
    ) {
      coaches {
        firstName
        lastName
        email
        users {
          firstName
          lastName
          email
          subscriptionEndDate
        }
      }
      month
      day
      week
      raw
    }
  }
`;

export const SALES_SUMMARY_QUERY = gql`
  query salesSummary($endDate: Date!) {
    salesSummary(endDate: $endDate) {
      id
      date
      totalAmount
      discountAmount
      recurringAmount
      newAmount
      revenueitemSet {
        id
        product {
          id
          title
          code
        }
        totalAmount
        discountAmount
        recurringAmount
        newAmount
      }
    }
  }
`;

export const XERO_REPORT_QUERY = gql`
  query adminXeroReport($startDate: Date!, $endDate: Date!) {
    adminXeroReport(startDate: $startDate, endDate: $endDate)
  }
`;

export const XERO_REFUND_REPORT_QUERY = gql`
  query adminXeroRefundReport($startDate: Date!, $endDate: Date!) {
    adminXeroRefundReport(startDate: $startDate, endDate: $endDate)
  }
`;

export const XERO_DISCOUNT_REPORT_QUERY = gql`
  query adminXeroDiscountReport($startDate: Date!, $endDate: Date!) {
    adminXeroDiscountReport(startDate: $startDate, endDate: $endDate)
  }
`;

export const PAYMENTS_EXPORT_REPORT_QUERY = gql`
  query adminPaymentsRecon($startDate: Date!, $endDate: Date!) {
    adminPaymentsRecon(startDate: $startDate, endDate: $endDate)
  }
`;

export const SERVED_CLIENTS_REPORT_QUERY = gql`
  query servedClientsRecon($startDate: Date!, $endDate: Date!) {
    servedClientsRecon(startDate: $startDate, endDate: $endDate)
  }
`;

export const PRIZE_QUALIFICATION_REPORT_QUERY = gql`
  query prizeQualification($startDate: Date!) {
    prizeQualification(startDate: $startDate)
  }
`;

export const BILLING_PRODUCTS_QUERY = gql`
  query billingProductsQuery($code: String, $isRecurring: Boolean) {
    billingProducts(code: $code, isRecurring: $isRecurring) {
      edges {
        node {
          id
          title
        }
      }
    }
  }
`;

export const SEND_BRAND_RETENTION_QUERY = gql`
  query sendBrandRetentionQuery {
    sendBrandRetention
  }
`;

export const BRAND_RETENTION_SUMMARY_QUERY = gql`
  query brandRetentionSummary(
    $reportType: String!
    $startDate: Date!
    $endDate: Date!
    $period: String!
    $acquisitionTypes: [String]
    $corporateTypes: [String]
    $discountCategories: [ID]
    $noDiscounts: Boolean
  ) {
    brandRetentionSummary(
      reportType: $reportType
      endDate: $endDate
      startDate: $startDate
      period: $period
      acquisitionTypes: $acquisitionTypes
      corporateTypes: $corporateTypes
      discountCategories: $discountCategories
      noDiscounts: $noDiscounts
    ) {
      data
    }
  }
`;

export const DISCOUNT_CATEGORIES_RETENTION_QUERY = gql`
  query discountCategories {
    discountCategories {
      id
      title
    }
  }
`;

export const SEND_SUBSCIRPTION_REPORT_QUERY = gql`
  query sendSubscriptionReport($startDate: Date!, $endDate: Date!) {
    sendSubscriptionReport(endDate: $endDate, startDate: $startDate)
  }
`;

export const CANCELLATIONS_PER_STAFF_QUERY = gql`
  query totalCancellationsPerStaff($startDate: Date!, $endDate: Date!, $excludeTransitions: Boolean) {
    totalCancellationsPerStaff(startDate: $startDate, endDate: $endDate, excludeTransitions: $excludeTransitions) {
      user {
        firstName
        lastName
        email
      }
      lifeCancellations
      clubCancellations
      oneOnOneCancellations
    }
  }
`;
